export default __webpack_public_path__ + "static/media/99d669f92f94543e53082d69c7f2fb3f.jpg";